export default "__VITE_ASSET__BuU5kWdY__"